import ValueTracker from "../../../../prop-trackers/value-tracker.js";
import DictTracker from "../../../../prop-trackers/dict-tracker.js";
import PropTracker from "../../../../prop-trackers/prop-tracker.js";
import { ForEach, ValueTracker as ForEachValueTracker } from "../../../../prop-tracker-utils/for-each.js";
import Zipper from "../../../../prop-tracker-utils/zipper.js";

class MorphTargetTrackerController {
    constructor(morphTracker, objectTracker, evtCtx, shlWrapCtx, shlEvtCtx, morphTargetController) {
        this._zipper = new Zipper();
        this._zipper.setSource("morphTargetInfluences", morphTracker);
        this._zipper.setSource("object", objectTracker);

        this._pairTracker = new DictTracker();
        this._forEachTracker = new ForEach(this._pairTracker, (key) => new ObjectTracker(evtCtx, morphTargetController));
    }

    update() {
        this._zipper.update(({ trackers }) => {
            for (const tracker of trackers) {
                tracker.update(({ userdata: key, props }) => {
                    const { newValue: morphTargetInfluences } = props.get("morphTargetInfluences");
                    const { newValue: object } = props.get("object");

                    if (morphTargetInfluences && object) {
                        this._pairTracker.setValue(key, { morphTargetInfluences, object });
                    } else {
                        this._pairTracker.deleteValue(key);
                    }
                });
            }
        });

        this._forEachTracker.update(({ trackers }) => {
            for (const tracker of trackers) {
                tracker.update();
            }
        });
    }
}

class ObjectTracker extends ForEachValueTracker {
    constructor(evtCtx, morphTargetController) {
        super();

        this._evtCtx = evtCtx;
        this._morphTargetController = morphTargetController;

        this._morphTracker = new ValueTracker();
        this._objectTracker = new ValueTracker();
        this._morphValueTracker = new PropTracker();

        const needsUpdate = () => this.protected_needsUpdate();
        this._morphTracker.listenNeedsUpdate(needsUpdate);
        this._objectTracker.listenNeedsUpdate(needsUpdate);
        this._morphValueTracker.listenNeedsUpdate(needsUpdate);
    }

    setValue(data) {
        let morphTargetInfluences, object;

        if (data) {
            ({ morphTargetInfluences, object } = data);
        }

        if (morphTargetInfluences && object) {
            this._morphTracker.setValue(morphTargetInfluences);
            this._objectTracker.setValue(object);
        } else {
            this.deleteValue();
        }
    }

    deleteValue() {
        this._morphTracker.deleteValue();
        this._objectTracker.deleteValue();
    }

    protected_startUpdate() {
        const updateMorphArray = this._morphTracker.needsUpdate;
        const updateObject = this._objectTracker.needsUpdate;
        if (updateMorphArray || updateObject) {
            this._morphTracker.update(({ prop: { newValue: morphInfl } }) => {
                if (updateMorphArray) {
                    this._morphValueTracker.track(morphInfl, morphInfl ? this._evtCtx.getEvents(morphInfl) : null);
                }

                this._objectTracker.update(({ prop: { oldValue: oldObject, newValue: newObject } }) => {
                    if (updateObject && oldObject) {
                        this._morphTargetController.clearInfluences(oldObject);
                    }

                    if (newObject) {
                        if (morphInfl) {
                            this._morphTargetController.setInfluences(newObject, morphInfl);
                        } else {
                            this._morphTargetController.clearInfluences(newObject);
                        }
                    }
                });

                this._morphValueTracker.update();
            });
        } else if (this._morphValueTracker.needsUpdate) {
            this._objectTracker.update(({ prop: { newValue: object } }) => {
                this._morphValueTracker.update(({ props }) => {
                    for (const { key: index, newExists, newValue } of props.iterateModified()) {
                        if (index !== "length") {
                            const infl = newExists ? newValue : 0;
                            this._morphTargetController.setInfluence(object, index, infl);
                        }
                    }
                });
            });
        }
    }

    protected_finishUpdate() {}
}

export default MorphTargetTrackerController;
